export class WebIntegrPerfilFuncADO {
    iD_PERFIL : number;
    iD_FUNCIONALIDADE : number;
    iD_PLANO : number;
    nM_PERFIL : string;
    nM_FUNCIONALIDADE : string;
    nM_PLANO : string;
 }